import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  useSeo({ title: "Page not found", description: "We couldn't find that page.", path: "/404" });
  return (
    <section className="ra-section">
      <div className="ra-container max-w-xl text-center">
        <span className="ra-eyebrow">404</span>
        <h1 className="mt-3 ra-h1">We couldn't find that page.</h1>
        <p className="mt-4 ra-lead">It may have been moved, or the link may be wrong. Let's get you back on course.</p>
        <Link to="/" className="ra-btn-primary mt-8 inline-flex" data-testid="notfound-home-link">
          <ArrowLeft size={16} /> Back home
        </Link>
      </div>
    </section>
  );
}
